import { WSButton, WSButtonProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { intercomService } from "@services/intercomService";

type Props = WSButtonProps<"Link">;

export const ButtonContactSupport: React.FC<Props> = props => {
  const { children, ...buttonProps } = props;

  return (
    <WSButton.Link
      {...buttonProps}
      onClick={intercomService.openErrorSupport}
      type="button"
    >
      {children}
    </WSButton.Link>
  );
};
